import useIndicator, { Indicator } from '@shared/hooks/src/useIndicator'

export default function usePendingHealthHistoryAlerts(options = {}) {
  const { data: pendingHealthHistory } = useIndicator(Indicator.PendingHealthHistoryAlerts, undefined, {
    select: (data) => data.count,
    refetchInterval: 60000,
    ...options,
  })

  return pendingHealthHistory
}
